export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-[#0F1419] py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-emerald-400 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Our Products</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight font-['Space_Grotesk']">
            Built for iOS.<br />
            <span className="text-white/40">Designed for People.</span>
          </h2>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* VPN Card */}
          <div className="relative rounded-3xl overflow-hidden group cursor-default" style={{ background: "linear-gradient(145deg, #1C2B1E 0%, #0F1F12 100%)" }}>
            <div className="absolute inset-0 border border-emerald-400/20 rounded-3xl" />

            {/* Background image */}
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://public.readdy.ai/ai/img_res/0ab59ccb5ee49166069f9f0ea4d02c13.jpg"
                alt="VPN security visualization"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="relative z-10 p-8 md:p-10 flex flex-col min-h-[480px]">
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-emerald-400/20 border border-emerald-400/30 mb-6">
                <i className="ri-shield-keyhole-line text-emerald-400 text-2xl" />
              </div>

              <div className="flex-1">
                <h3 className="text-4xl md:text-5xl font-black text-white mb-3 font-['Space_Grotesk']">VPN</h3>
                <p className="text-white/50 text-sm font-medium tracking-widest uppercase mb-4">Security &amp; Privacy</p>
                <p className="text-white/70 text-base leading-relaxed mb-6">
                  Protect your online identity and secure your internet connection with military-grade encryption. Browse privately, access content freely, and stay safe on any network.
                </p>

                <ul className="flex flex-col gap-2">
                  {["End-to-end encryption", "Zero-log policy", "Global server network", "One-tap connection"].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-white/60 text-sm">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-emerald-400 text-xs" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                <span className="text-white/30 text-xs tracking-widest uppercase">iOS Application</span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-400/10 border border-emerald-400/20">
                  <i className="ri-apple-line text-emerald-400 text-sm" />
                </div>
              </div>
            </div>
          </div>

          {/* Cleaner Card */}
          <div className="relative rounded-3xl overflow-hidden group cursor-default" style={{ background: "linear-gradient(145deg, #2B1F1A 0%, #1F1410 100%)" }}>
            <div className="absolute inset-0 border border-amber-400/20 rounded-3xl" />

            {/* Background image */}
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20clean%20minimalist%20digital%20optimization%20concept%20with%20glowing%20amber%20orange%20circular%20patterns%20and%20geometric%20shapes%20on%20very%20dark%20background%2C%20performance%20boost%20aesthetic%2C%20warm%20tones%2C%20no%20text%2C%20ultra%20wide&width=600&height=700&seq=cleaner001&orientation=portrait"
                alt="Cleaner performance visualization"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="relative z-10 p-8 md:p-10 flex flex-col min-h-[480px]">
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-amber-400/20 border border-amber-400/30 mb-6">
                <i className="ri-speed-up-line text-amber-400 text-2xl" />
              </div>

              <div className="flex-1">
                <h3 className="text-4xl md:text-5xl font-black text-white mb-3 font-['Space_Grotesk']">Cleaner</h3>
                <p className="text-white/50 text-sm font-medium tracking-widest uppercase mb-4">Performance &amp; Optimization</p>
                <p className="text-white/70 text-base leading-relaxed mb-6">
                  Reclaim storage space and boost your device performance. Remove junk files, duplicate photos, and unnecessary data to keep your iPhone running at its best.
                </p>

                <ul className="flex flex-col gap-2">
                  {["Smart junk detection", "Duplicate photo finder", "Storage analyzer", "One-tap deep clean"].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-white/60 text-sm">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-amber-400 text-xs" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                <span className="text-white/30 text-xs tracking-widest uppercase">iOS Application</span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-400/10 border border-amber-400/20">
                  <i className="ri-apple-line text-amber-400 text-sm" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
